import { Button, Col, Form, Modal, notification, Row } from "antd";
import { useState } from "react";
import FloatInput from "../common/components/FloatInput";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks";
import ConfirmModal from "../common/components/ConfirmModal";
import { toggleLoginModal } from "../login/redux/LoginSlice";
import { toggleForgotPasswordModal } from "./redux/ForgotPasswordSlice";
import { useLazyGenerateOtpQuery, useValidateOtpAndChangePassMutation, useValidateOtpChangePassMutation } from "./redux/ForgotPasswordApi";
import { usePrompt } from "../prompts";
import { OTPActions } from "../common/types/types";

const pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

const ForgotPassword = () => {
    const state = useAppSelector(state => state.forgotPassword);
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [enterCode, setEnterCode] = useState(false);
    const [changePass, setChangePass] = useState(false);
    const [visible, setVisible] = useState(false);
    const [getCodeError, setGetCodeError] = useState();
    const [confirmError, setConfirmError] = useState();
    const [cancelVisible, setCancelVisible] = useState(false);
    const [count, setCount] = useState<any>([]);

    const [trigger] = useLazyGenerateOtpQuery();
    const [validateOtp] = useValidateOtpChangePassMutation();
    const [validatePassword] = useValidateOtpAndChangePassMutation();

    usePrompt(enterCode || changePass);

    const toggleVisible = () => {
        setVisible(!visible);
    }

    const openLogin = () => {
        dispatch(toggleForgotPasswordModal());
        dispatch(toggleLoginModal());
    }

    const buttonActions = () => {
        if (!enterCode && !changePass) {
            getCode();
        } else if (enterCode && !changePass) {
            verifyCode();
        } else if (changePass) {
            changePassword();
        }
    }

    const buttonTexts = () => {
        if (!enterCode && !changePass) {
            return "LẤY MÃ XÁC NHẬN";
        }
        return "ĐỔI MẬT KHẨU";
    }

    const getCode = () => {
        form.validateFields(["email"]).then((values) => {
            setLoading(true);
            trigger({ email: values.email, action: OTPActions.RESET_PASSWORD }).unwrap().then(res => {
                setLoading(false);
                setEnterCode(true);
            }).catch(err => {
                // notification.error({
                //     message: err.data?.message || "Đã có lỗi xảy ra. Vui lòng thử lại sau!"
                // })
                setGetCodeError(err.data?.message || "Đã có lỗi xảy ra. Vui lòng thử lại sau!");
                form.validateFields();
                setLoading(false);
            })
        }).catch((err) => {
            console.error(err);
        })
    }

    const verifyCode = () => {
        form.validateFields(["code"]).then((values) => {
            setLoading(true);
            validateOtp({ email: form.getFieldValue("email"), otp: values.code }).unwrap().then(res => {
                setLoading(false);
                setEnterCode(false);
                setChangePass(true);
            }).catch(err => {
                setLoading(false);
                // notification.error({
                //     message: err.data?.message || "Đã có lỗi xảy ra. Vui lòng thử lại sau!"
                // })
                setConfirmError(err.data?.message || "Đã có lỗi xảy ra. Vui lòng thử lại sau!");
                form.validateFields();
            })
        }).catch(err => {
            console.error(err);
        })
    }

    const changePassword = () => {
        form.validateFields(["password", "confirmPassword"]).then((values) => {
            setLoading(true);
            validatePassword({
                newPassword: values.password,
                confirmPassword: values.confirmPassword,
                email: form.getFieldValue("email"),
                otp: form.getFieldValue("code"),
            }).unwrap().then(res => {
                setLoading(false);
                notification.success({
                    message: "Thay đổi mật khẩu tài khoản thành công"
                })
                dispatch(toggleForgotPasswordModal());
            }).catch(err => {
                setLoading(false);
                toggleVisible();
                notification.error({
                    message: err.data?.message || "Đã có lỗi xảy ra. Vui lòng thử lại sau!"
                })
            })
        }).catch(err => {
            console.error(err);
        })
    }

    const onCancel = () => {
        if (enterCode || changePass) {
            setCancelVisible(true);
        } else {
            dispatch(toggleForgotPasswordModal())
        }
    }

    const onValuesChange = (changedValues: any) => {
        let key = Object.keys(changedValues)[0];
        let value = changedValues[key];
        if (typeof (value === "string")) {
            setCount({
                ...count,
                [key]: value.length,
            });
        }
    }

    return (
        <Modal
            visible={state.modalVisible}
            onCancel={onCancel}
            className="custom-modal"
            footer={false}
            bodyStyle={{ padding: '60px 0px' }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span className="font-size-30">Quên mật khẩu</span>
            </div>
            <Form
                className="custom-form"
                style={{ marginTop: 45, marginBottom: 35 }}
                name="register"
                form={form}
                colon={false}
                autoComplete="off"
                onValuesChange={onValuesChange}
            >
                <Row justify="center" align="middle">
                    <Col span={14} className={changePass ? "form-hidden" : "form-show"}>
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    required: !enterCode && !changePass, type: "email",
                                    message: "Vui lòng nhập email đúng định dạng."
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!getCodeError) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(getCodeError));
                                    },
                                }),
                            ]}
                        >
                            <FloatInput onChange={() => setGetCodeError(undefined)} maxLength={50} disabled={enterCode || changePass} placeholder="Email đã đăng ký" label="Email" />
                        </Form.Item>
                    </Col>
                    <Col span={14} className={!enterCode ? "form-hidden" : "form-show"}>
                        <Form.Item
                            name="code"
                            rules={[
                                { required: enterCode && !changePass, message: "Vui lòng nhập mã xác nhận." },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!confirmError) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error(confirmError));
                                    },
                                }),
                            ]}
                        >
                            <FloatInput onChange={() => setConfirmError(undefined)} placeholder="Nhập mã xác nhận" label="Mã xác nhận" maxLength={8} />
                        </Form.Item>
                    </Col>
                    <Col span={14} className={!changePass ? "form-hidden" : "form-show"}>
                        <Form.Item
                            name="password"
                            rules={[
                                { required: changePass, message: "Vui lòng nhập mật khẩu mới." },
                                { pattern, message: "Tối thiểu 8 ký tự (số, chữ cái và ký tự đặc biệt)." }
                            ]}
                        >
                            <FloatInput placeholder="Mật khẩu mới" label="" isPassword autoComplete="off" maxLength={20} />
                        </Form.Item>
                        <label className="input-show-count">{count.password || 0}/20</label>
                    </Col>
                    <Col span={14} className={!changePass ? "form-hidden" : "form-show"}>
                        <Form.Item
                            name="confirmPassword"
                            dependencies={["password"]}
                            rules={[
                                { required: changePass, message: "Vui lòng nhập lại mật khẩu mới." },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Mật khẩu nhập lại không khớp!'));
                                    },
                                }),
                            ]}
                        >
                            <FloatInput placeholder="Nhập lại mật khẩu mới" label="" isPassword autoComplete="off" maxLength={20} />
                        </Form.Item>
                        <label className="input-show-count">{count.confirmPassword || 0}/20</label>
                    </Col>
                </Row>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Button
                        htmlType="submit"
                        disabled={loading}
                        className={loading ? "button-light-gray" : "button-light-yellow"}
                        style={{ width: 240, height: 50 }}
                        onClick={buttonActions}
                        loading={loading}>{buttonTexts()}</Button>
                </div>
            </Form>
            <div style={{ textAlign: 'center' }}>
                <span className="anchor-text" onClick={openLogin}>Đăng nhập ngay</span>
                <span className="anchor-text" style={{ marginLeft: 30, display: enterCode ? "inline" : "none" }} onClick={getCode}>Gửi lại mã xác nhận</span>
            </div>
            {
                toggleVisible &&
                <ConfirmModal
                    noCancelButton={true}
                    onCancel={toggleVisible}
                    onOk={toggleVisible}
                    status="error"
                    title={<div style={{ textAlign: 'center' }}>
                        <div className="font-size-16">Mật khẩu mới không hợp lệ!</div>
                        {/* <div className="font-size-16">Mật khẩu mới phải khác mật khẩu cũ gần đây nhất.</div> */}
                    </div>}
                    visible={visible}
                />
            }
            {cancelVisible ?
                <ConfirmModal
                    visible={cancelVisible}
                    status="error"
                    onOk={() => dispatch(toggleForgotPasswordModal())}
                    onCancel={() => setCancelVisible(false)}
                    title={<div style={{ textAlign: 'center' }}>
                        <div className="font-size-16">Bạn có chắc chắn muốn thoát và không lưu dữ liệu vừa nhập</div>
                    </div>}
                /> : <></>}
        </Modal >
    )
}

export default ForgotPassword;